import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { fmtDateTime, label } from "../../lib/format";
import { ConfigTable } from "../../components/common/ConfigTable";
import { Card, PageHeader, Td, Th } from "../../components/common/UI";

export default function Numbering() {
  const [data, setData] = useState(null);
  const [workflows, setWorkflows] = useState([]);
  useEffect(() => {
    api.get("/numbering/sequences").then((r) => setData(r.data));
    api.get("/workflows").then((r) => setWorkflows(r.data));
  }, []);
  return (
    <div className="fade-up space-y-6">
      <PageHeader eyebrow="Administration" title="Numbering Rules" subtitle="Numbers are allocated inside an InnoDB transaction with a row lock on the sequence. Changing a format affects only future allocations." />
      <ConfigTable testId="measure-types-table" endpoint="/measure-types" title="Measure types and number formats" editPerm="numbering.manage"
        note="Placeholders: {prefix}, {seq}, {year}, {term}"
        defaults={{ category: "ordinance", numbering_format: "{prefix} No. {seq}, Series of {year}", numbering_scope: "year", sequence_padding: 3, is_active: true }}
        columns={[{ key: "code", label: "Code" }, { key: "name", label: "Name" }, { key: "category", label: "Category", render: (r) => label(r.category) },
          { key: "numbering_format", label: "Format", render: (r) => <code className="text-[11px]">{r.numbering_format}</code> }, { key: "numbering_scope", label: "Scope", render: (r) => label(r.numbering_scope) }]}
        fields={[{ name: "code", label: "Code", required: true }, { name: "name", label: "Name", required: true },
          { name: "category", label: "Category", type: "select", required: true, options: ["ordinance", "resolution", "other"].map((v) => ({ value: v, label: label(v) })) },
          { name: "number_prefix", label: "Prefix", required: true }, { name: "numbering_format", label: "Format", required: true, wide: true },
          { name: "numbering_scope", label: "Sequence resets per", type: "select", required: true, options: [{ value: "year", label: "Calendar year" }, { value: "term", label: "Legislative term" }, { value: "term_year", label: "Term and year" }] },
          { name: "sequence_padding", label: "Digits", type: "number", required: true },
          { name: "workflow_definition_id", label: "Workflow (blank = LGU default)", type: "select", options: workflows.map((w) => ({ value: w.id, label: w.name })) },
          { name: "is_active", label: "Active", type: "bool" }]} />
      {data && (
        <div className="grid gap-6 lg:grid-cols-2">
          <Card title="Next number preview (current term)" testId="next-numbers">
            <ul className="space-y-2">
              {data.next_numbers.map((n) => <li key={n.measure_type_id} className="flex justify-between text-xs"><span className="text-slate-500">{n.measure_type_name}</span><span className="font-medium" data-testid={`next-number-${n.measure_type_id}`}>{n.next}</span></li>)}
            </ul>
          </Card>
          <Card title="Sequences" testId="sequences-table">
            <table className="w-full">
              <thead><tr><Th>Type</Th><Th>Scope</Th><Th>Current</Th><Th>Updated</Th></tr></thead>
              <tbody>{data.sequences.map((s) => <tr key={s.id}><Td>{s.measure_type_name}</Td><Td className="font-mono">{s.scope_key.startsWith("T:") ? "term" : s.scope_key}</Td><Td>{s.current_value}</Td><Td>{fmtDateTime(s.updated_at)}</Td></tr>)}</tbody>
            </table>
          </Card>
        </div>
      )}
    </div>
  );
}
